/**
 * Saves client details.
 */
var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function savesClientDetails(client, sDispatch) {

    const abortController = new AbortController();

    const request = {   
        companyid:client.companyID,
        companyname:client.companyName,
        address1:client.address1,
        address2:client.address2,
        city: client.city,
        county: client.county,
        country:client.country,
        postcode:client.postcode,
        telephone:client.telephone,
        credit_limit:client.creditLimit,
        hasvat:true,
        status:client.status,
        ctype:client.companyType,
        pricemodelid:client.pricingModelID,
        findid:client.findID,
        zohoid:client.zohoID
    };

    //console.log("savesClientDetails "+JSON.stringify(request));

    let mounted = true;
    (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/find/client/register/save', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
            if (data.status === "success"){
                sDispatch({
                    type: "setClientRegister",
                    payload: { clientRegister: data.clients }
                });
            }
        }
        const cleanup = () => {
            mounted = false;
            abortController.abort();
        };
        return cleanup;
    
    })();

}
